<script>
    import { onMount } from "svelte";

    import { apiMethods } from "../../../Services/index.svelte";

    import {
        showError,
        showException,
    } from "../../../Utils/utilFunctions.svelte";

    export let personalDetails = {};
    export let updatePersonalDetailsPhase = () => {};

    const __RESEND__COOLDOWN = 60000;
    const __CHECKVERIFICATION__COLLDOWN = 2000;

    let smsVerificationCode = "",
        isSendingVerificationCode = false;

    let isResendingCount = false,
        resendCoolDown = __RESEND__COOLDOWN;

    $: isValidVerificationCode = smsVerificationCode
        ? smsVerificationCode.length == 6
        : false;

    $: isValidBtnDisabled =
        !isValidVerificationCode || isSendingVerificationCode;

    $: if (smsVerificationCode.length == 6) {
        window.addEventListener("keydown", (e) => {
            if (e.key == "Enter") validatePhone();
        });
    } else if (smsVerificationCode.length)
        window.removeEventListener("keydown", (e) => {
            if (e.key == "Enter") validatePhone();
        });

    onMount(async () => {
        if (personalDetails.phone) {
            await sendVerificationSms();

            checkPhoneVerification();
        }
    });

    const validatePhone = async () => {
        isSendingVerificationCode = true;

        await apiMethods.postMethod
            .validatePhone({ code: smsVerificationCode })
            .then((res) => {
                if (!res) {
                    showError(
                        "Failed to validate your phone, please check your SMS code and try again",
                    );
                    clearVerificationCode();
                }
            })
            .catch((err) =>
                showException(
                    err ??
                        "Failed to validate your phone, please contact support...",
                ),
            );

        isSendingVerificationCode = false;
    };

    const sendVerificationSms = async (isRend = false) => {
        await apiMethods.postMethod.sendVerificationSms();

        if (isRend) _updateCountDown();
    };

    const checkPhoneVerification = () => {
        const checkProcess = () => {
            apiMethods.getMethod
                .getUserById(personalDetails.createdUserId)
                .then((res) => {
                    if (res.id == personalDetails.createdUserId) {
                        if (res.verifiedPhone) updatePersonalDetailsPhase(3);
                        else
                            setTimeout(
                                checkProcess,
                                __CHECKVERIFICATION__COLLDOWN,
                            );
                    } else if (res.error) showError(res.error);
                });
        };

        setTimeout(() => {
            checkProcess();
        }, __CHECKVERIFICATION__COLLDOWN);
    };

    const resendSms = () => {
        isResendingCount = true;

        sendVerificationSms(true);
    };

    const clearVerificationCode = () => {
        smsVerificationCode = "";

        for (let i = 0; i < 6; i++) {
            const inputFiled = document.querySelector(`#codeInput${i}`);

            inputFiled.value = "";
        }
    };

    // HELPER FUNCTIONS
    const _handleVerificationInput = (event, index) => {
        const { value } = event.target;

        if (value.length > 1) event.target.value = value.slice(0, 1);

        smsVerificationCode =
            smsVerificationCode.substr(0, index) +
            value +
            smsVerificationCode.substr(index + 1);

        if (value && index < 5) {
            const nextInput = document.querySelector(`#codeInput${index + 1}`);
            nextInput.focus();
        } else {
            const firstInput = document.querySelector(`#codeInput0`);
            firstInput.focus();
        }
    };

    const _updateCountDown = () => {
        const countDown = () => {
            resendCoolDown -= 1000;

            if (resendCoolDown < 0) {
                clearInterval(timer);
                isResendingCount = false;
                resendCoolDown = __RESEND__COOLDOWN;
            }
        };

        const timer = setInterval(countDown, 1000);
    };
</script>

<form
    on:submit|preventDefault={validatePhone}
    novalidate
    class="flex flex-col gap-y-4 p-4 w-full max-h-[600px] overflow-y-auto"
>
    <div class="flex flex-col gap-y-2">
        <p class="text-[16px] text-gray-600">
            We require your mobile number in order to provide two-factor
            authentication and send you important SMSes
            <span class="font-bold">{personalDetails.phone}</span>
        </p>

        <p class="text-[16px] text-gray-600">
            Enter the 6-digit code that was sent to your mobile number.
        </p>
    </div>

    <div class="flex flex-1 justify-between items-center gap-x-4">
        <div class="flex flex-1 gap-x-4">
            {#each Array.from({ length: 6 }) as _, index}
                <input
                    type="text"
                    id={`codeInput${index}`}
                    class="outline outline-offset-0 outline-1 outline-gray-600 flex justify-center text-[16px] w-[40px] h-[40px] text-center rounded-lg focus:outline-offset-2 focus:outline-2"
                    inputmode="numeric"
                    maxlength="1"
                    autocomplete="off"
                    on:input={(e) => _handleVerificationInput(e, index)}
                />
            {/each}
        </div>

        <button
            class="btn btn-sm btn-secondary"
            on:click|preventDefault={clearVerificationCode}>Clear</button
        >
    </div>

    <div class="flex flex-1 justify-between">
        <p class="text-[16px] text-gray-600">Can't find the sms?</p>

        <button
            class="btn btn-sm btn-secondary"
            on:click|preventDefault={resendSms}
            disabled={isResendingCount}
        >
            Resend {isResendingCount
                ? `(${Math.floor(resendCoolDown / 1000)})`
                : ""}
        </button>
    </div>

    <div class="flex w-full">
        <button
            class="btn btn-sm btn-secondary w-full"
            disabled={isValidBtnDisabled}
            on:click|preventDefault={validatePhone}
        >
            Validate
        </button>
    </div>
</form>
